'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_UnknownPage(str) {
  this.Kj = null;
  this.Kj = str;
}
export { $c_Lpresto_UnknownPage as $c_Lpresto_UnknownPage };
$p = $c_Lpresto_UnknownPage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_UnknownPage;
/** @constructor */
function $h_Lpresto_UnknownPage() {
}
export { $h_Lpresto_UnknownPage as $h_Lpresto_UnknownPage };
$h_Lpresto_UnknownPage.prototype = $p;
$p.dl = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_UnknownPage) && (this.Kj === x$0.Kj)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "UnknownPage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Kj;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_UnknownPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j0)));
}
export { $isArrayOf_Lpresto_UnknownPage as $isArrayOf_Lpresto_UnknownPage };
var $d_Lpresto_UnknownPage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_UnknownPage, "presto.UnknownPage", ({
  j0: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_UnknownPage as $d_Lpresto_UnknownPage };
//# sourceMappingURL=presto.-Unknown-Page.js.map
